// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Browser__Identity$SmartcutsMacros = require("../../browser/Browser__Identity.bs.js");
var GoogleSheetHelpers$SmartcutsMacros = require("../../GoogleSheetHelpers.bs.js");

function getAuthTokenAndGapiClient(param) {
  return Promise.all([
              Browser__Identity$SmartcutsMacros.getAuthToken(true, false, undefined, undefined, undefined),
              GoogleSheetHelpers$SmartcutsMacros.loadClientButReloadExtensionIfGapiIsNotDefined(undefined)
            ]);
}

exports.getAuthTokenAndGapiClient = getAuthTokenAndGapiClient;
/* GoogleSheetHelpers-SmartcutsMacros Not a pure module */
